import { render, staticRenderFns } from "./BrbTabs.vue?vue&type=template&id=116bcd3c&"
import script from "./BrbTabs.vue?vue&type=script&lang=js&"
export * from "./BrbTabs.vue?vue&type=script&lang=js&"
import style0 from "./BrbTabs.vue?vue&type=style&index=0&id=116bcd3c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116bcd3c')) {
      api.createRecord('116bcd3c', component.options)
    } else {
      api.reload('116bcd3c', component.options)
    }
    module.hot.accept("./BrbTabs.vue?vue&type=template&id=116bcd3c&", function () {
      api.rerender('116bcd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbTabs.vue"
export default component.exports